export default __webpack_public_path__ + "static/media/login-bg.794e0506.png";